import { BehaviorSubject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { BlocksAssetType, BlocksTranslationsType } from '../../model/blocks-types';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export class StartViewModel {
  public get playLabelText() {
    return this.gameServices.gameTranslationService.getTranslation(BlocksTranslationsType.Play);
  }
  public get buttonAsset() {
    return this.gameServices.assetCatalogueService.getAsset(BlocksAssetType.StartButton);
  }
  public get buttonIcon() {
    return this.gameServices.assetCatalogueService.getAsset(BlocksAssetType.PlayIcon);
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get onShowStartButtonTrigger() {
    return this.showStartButtonTrigger.asObservable();
  }

  private readonly showStartButtonTrigger = new BehaviorSubject<boolean>(false);

  constructor(private gameServices: GameServices) {}

  public calculateScaleFactor(gameSizeMetrics: GameSizeMetrics): {
    scaledOffsetX: number;
    scaleFactor: number;
  } {
    return this.gameServices.gameMetricsService.calculateBoardScaling(gameSizeMetrics);
  }

  public showStartButton(showButton: boolean) {
    this.showStartButtonTrigger.next(showButton);
  }

  public startClicked() {
    this.gameServices.gameRunnerService.startGame();
  }
}
